import {santaSearchBox} from './SearchBox';
import {$skin as skin} from './SearchBox.st.css';

export default {
  componentType: 'wixui.SearchBox',
  component: santaSearchBox,
  santaComponent: santaSearchBox,
  skin
};
